import React from "react";

function BS4_Toast() {
  return (
    <div>
      <h1>BS4_Toast Component</h1>
      <p>This is the BS4_Toast tutorial page content.</p>
    </div>
  );
}

export default BS4_Toast;
